// import AOS from 'aos';
import Splide from '@splidejs/splide';
import { unitlessBreakpoints } from './breakpoints';

const selectors = {
  mainCarousel: '[data-splide-carousel]',
};

const initCarousel = (el, options = {}, replaceOptions = false) => {
  const carousel = el.querySelector(selectors.mainCarousel);
  let carouselOptions = {};

  if (carousel) {
    carouselOptions = {
      perPage: 1,
      pagination: false,
      perMove: 1,
      gap: '1rem',
      mediaQuery: 'min',
      breakpoints: {
        [unitlessBreakpoints.sm]: {
          perPage: 2,
        },
        [unitlessBreakpoints.md]: {
          perPage: 3,
        },
        [unitlessBreakpoints.lg]: {
          perPage: 4,
        },
      },
      ...options,
    };

    if (replaceOptions) {
      carouselOptions = options;
    }

    const splide = new Splide(carousel, carouselOptions).mount();

    if (splide.length <= splide.options.perPage) {
      splide.options = {
        arrows: false,
      };
    }

    splide.on('hidden', () => {
      if (splide.length > splide.options.perPage) {
        splide.options = {
          arrows: true,
        };
      }
    });
    splide.on('visible', () => {
      if (splide.length <= splide.options.perPage) {
        splide.options = {
          arrows: false,
        };
      }
    });

    // AOS.refresh();
  }
};

export default initCarousel;
